import {
  CardElement,
  useElements
} from '@stripe/react-stripe-js'
import Form from 'components/Form'
import { STYLES_FONT_SIZE_PX } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { View } from 'components/View.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { shouldFocusCardElementStripeSelect } from 'modules/stripe/redux/selectors/should-focus-card-element/index.js'
import { updateShouldFocusCardElementStripeAction } from 'modules/stripe/redux/actions/update-should-focus-card-element/index.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import runAfterDelayPromisifiedPerformanceUtil from 'modules/performance/run-after-delay-promisified/index.js'

const DELAY_BEFORE_FOCUS_IN_MS = 1000

const StripeCardForm = React.memo(function StripeCardForm (props) {
  const shouldFocusCardElement = useSelector(shouldFocusCardElementStripeSelect)
  const elements = useElements()
  const dispatch = useDispatch()

  const focus = async () => {
    const cardElement = elements.getElement(CardElement)
    if (cardElement) {
      await runAfterDelayPromisifiedPerformanceUtil({
        delay: DELAY_BEFORE_FOCUS_IN_MS
      })
      cardElement.focus()
    }
  }

  React.useEffect(() => {
    if (shouldFocusCardElement) {
      focus()
      dispatch(updateShouldFocusCardElementStripeAction(false))
    }
  }, [shouldFocusCardElement])

  return (
    <Form onSubmit={props.onSubmit}>
      <View style={{
        padding: '0.55em',
        border: '0.055em solid rgb(230, 230, 230)',
        borderRadius: '4px',
        backgroundColor: '#fff'
      }}
      >
        <CardElement
          onChange={props.onChange}
          // onReady={el => el.focus()}
          options={{
            style: {
              base: {
                fontSize: `${STYLES_FONT_SIZE_PX.SMALL}px`
              }
            },
            hidePostalCode: true
          }}
        />
      </View>
    </Form>
  )
})

export default StripeCardForm
